<template>
  <Modal ref="modal" title="Confirmar">
    <div class="confirm-container">
      <div class="infos">
        <p>Deseja mesmo gerar o boleto?</p>
        <span>Valor: {{ utils.formatarValor(value) }}</span>
      </div>

      <div class="actions">
        <Button type="button" @handle:click="handleCancel" text="Cancelar" color="danger" :disabled="loading">
          <CloseCircleOutline :size="18" />
        </Button>

        <Button type="button" @handle:click="handleConfirm" text="Confirmar" color="primary" :disabled="loading">
          <CheckOutline :size="18" />
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import utils from '../../services/utils'
import Modal from '../core/Modal'
import Button from '../core/Button'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import CheckOutline from 'icons/CheckOutline'

export default {
  name: 'ConfirmModal',
  components: {
    CloseCircleOutline,
    CheckOutline,
    Modal,
    Button,
  },
  props: {
    value: {
      type: String | Number,
      default: 0.0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      utils: utils,
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    handleConfirm() {
      this.$emit('handle:confirm')
    },
    handleCancel() {
      this.close()
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.confirm-container {
  width: 20vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .infos {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    p {
      margin: 0;
      font-size: 1.125rem;
    }

    span {
      font-size: 1.25rem;
      font-weight: 600;
    }
  }

  .actions {
    align-self: flex-end;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>